import { Outlet } from 'react-router-dom';
import { MainLayoutContainer, MainLayoutContent } from './style';
import { LanguageSync } from '../../../features/Translations/components/LanguageSync';

export function MainLayout() {
	return (
		<MainLayoutContainer>
			<LanguageSync />
			<MainLayoutContent>
				<Outlet />
			</MainLayoutContent>
		</MainLayoutContainer>
	);
}
